module.exports = __webpack_public_path__ + "img/Serial.c74f992a.svg";